'use client';

import { useEffect, useState } from 'react';
import type { MouseEvent } from 'react';

import { CourseCardFavoriteButton } from '@/features/course-card/components/CourseCardFavoriteButton';

export interface FavoriteButtonWidgetProps {
  courseId: string;
  isFavorite?: boolean;
  className?: string;
  onToggle?: (courseId: string, nextFavorite: boolean) => void;
}

export function FavoriteButtonWidget({
  courseId,
  isFavorite = false,
  className,
  onToggle,
}: FavoriteButtonWidgetProps) {
  const [favorite, setFavorite] = useState(isFavorite);

  useEffect(() => {
    setFavorite(isFavorite);
  }, [isFavorite]);

  const handleToggle = (_event: MouseEvent<HTMLButtonElement>) => {
    const next = !favorite;
    setFavorite(next);
    onToggle?.(courseId, next);
  };

  return (
    <CourseCardFavoriteButton isFavorite={favorite} className={className} onToggle={handleToggle} />
  );
}
